"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

import { captureAttribution } from "@/lib/analytics/attribution";

export function AttributionCapture({
  consentGranted,
}: {
  consentGranted: boolean;
}) {
  const pathname = usePathname();

  useEffect(() => {
    if (consentGranted) captureAttribution();
  }, [consentGranted, pathname]);

  return null;
}
